module.exports = {"341821100":"建平镇","341821101":"十字镇","341821102":"新发镇","341821103":"涛城镇","341821105":"梅渚镇","341821107":"毕桥镇","341821108":"飞鲤镇","341821109":"凌笪镇","341821110":"姚村镇","341821400":"郎溪经济开发区","341821500":"安徽省国营十字铺茶场","341821501":"上海市白茅岭监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341821.json
// module id = 1261
// module chunks = 0